import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class personalInfoAuthNotice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // document.title = '充电安全须知';
    return (
      <div className="page_type_h5_select">
        <div id="personalInfoAuthNotice">
          <h3>
            为保护您的个人信息权益，请您在开启充电服务之前，仔细阅读我们的个人信息授权须知。如您不同意本须知内容，或无法准确理解本须知任何条款的内容，请不要进行确认或后续操作。
          </h3>

          <p>
            您授权浙江绿色慧联有限公司（以下简称“我们”）将您充电订单号提供给为您提供服务的充电桩运营方，以便于完成充电订单。
          </p>
          <p>
            同时，由于部分充电场站所在的停车位运营方可以为您提供限时免费停车优惠，若您希望享受此项服务，您授权我们将您向我们提供的车牌号共享给充电桩运营方。
          </p>
          <p>
            请注意，不同区域的充电桩运营方要求不同，所需字段可能有所差异，具体字段以实际为您提供服务的充电桩运营方所需数据字段为准。
          </p>
          <p>
            请您理解，我们会尽最大努力保障您的个人信息安全，并严格要求第三方充电桩运营方对您的个人信息保密，只以为您提供充电服务之目的获悉和使用，不得对无关方泄露或做其他任何用途。
          </p>
        </div>
      </div>
    );
  }
}

export default personalInfoAuthNotice;



// WEBPACK FOOTER //
// ./src/staticPage/personalInfoAuthNotice/index.js